import { render } from "./UserFilters.vue?vue&type=template&id=2623bd88&scoped=true"
import script from "./UserFilters.vue?vue&type=script&lang=js"
export * from "./UserFilters.vue?vue&type=script&lang=js"

import "./UserFilters.vue?vue&type=style&index=0&id=2623bd88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2623bd88"]])

export default __exports__